import { UserApi } from './http-common';
import GroupRepresentation from '../model/GroupRepresentation';

export const updatePreference = ({ id, lg, site }) => new Promise(() => {
  UserApi.put(`/${id}`, null, { params: { lg, site } },
    { headers: { 'Authorization': `Bearer ${localStorage.getItem('vue-token')}` } });
});

export const findGroupNameByUsersId = userId => new Promise((resolve, reject) => {
  if (!userId) {
    reject('userId should be provided');
  }

  UserApi.get('/groups', {
    params: {
      userId
    },
    headers: { 'Authorization': `Bearer ${localStorage.getItem('vue-token')}` }
  }).then(response => {
    resolve(response.data.map(userGroup => GroupRepresentation.parse(userGroup)));
  })
    .catch(error => reject(error));
});


